var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_2500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 95.957C74.5097 95.957 96 74.4763 96 47.9785C96 21.4807 74.5097 0 48 0C21.4903 0 0 21.4807 0 47.9785C0 74.4763 21.4903 95.957 48 95.957Z",
    fill: "#F5A2A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 97C74.5097 97 96 75.5192 96 49.0215C96 22.5237 74.5097 1.04297 48 1.04297C21.4903 1.04297 0 22.5237 0 49.0215C0 75.5192 21.4903 97 48 97Z",
    fill: "url(#paint0_linear_45_2500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5195 72.145L68.8274 49.0215L35.5195 25.8979V72.145Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_2500",
    x1: 0,
    y1: 49.0215,
    x2: 96,
    y2: 49.0215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF518C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66319B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_2500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 97,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg4);
export default __webpack_public_path__ + "static/media/svg-4.1570f9c682d39410a172835fc745f25d.svg";
export { ForwardRef as ReactComponent };